// One place for money display, so the table, the cards and the calendar
// summary can never disagree about decimals or grouping.
export const formatPnlInr = (value) => {
  const num = parseFloat(value);
  if (!Number.isFinite(num)) return '\u20B90.00';
  const sign = num < 0 ? '-' : '';
  return `${sign}\u20B9${Math.abs(num).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

// Rates carry more precision than P&L (e.g. 91.166), so they keep up to four
// decimals and pad none.
export const formatRateInr = (value) => {
  const num = parseFloat(value);
  if (!Number.isFinite(num)) return '-';
  return `\u20B9${num.toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 4 })}`;
};
